// extracted by mini-css-extract-plugin
export default {"list":"PostList_list__ChgBe"};